import * as Yup from 'yup'
const scraperProductCreateSchema = Yup.object().shape(
  {
    website: Yup.string().required(
      'Website is Required'
    ),
    original_sku: Yup.string().required(
      'Original SKU is required'
    ),
    brand: Yup.string().required(
      'Brand is required'
    ),
    size: Yup.string().required(
      'Size is required'
    ),
    condition: Yup.string().required(
      'Condition is required'
    ),
    gender: Yup.string().required(
      'Gender is required'
    ),
    category: Yup.string().required(
      'Category is required'
    ),
    price: Yup.number(
    ).min(
      50000, 'Price should be higher than Rp.50.000,-'
    ).required(
      'Price is required'
    ),
    delivery_days: Yup.number(
    ).required(
      'Delivery Days is required'
    ),
    colour: Yup.string().required(
      'Colour is required'
    ),
    product_url: Yup.string().url(
      'Product URL must be a valid URL'
    ).required(
      'Product URL is Required'
    )
  }
)

export default scraperProductCreateSchema
